import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import {shortLabels, toggleTooltip} from '../lib/utils';
import styled from 'styled-components';

const StyledListHead = styled.ul`
    border-radius: 5px;
    box-shadow: 0 2px 4px 0 rgba(51, 51, 51, .15);
    display: table;
    width: 100%;
    overflow: hidden;
    font-size: .688em;
    margin: 0 0 4px 0;
    letter-spacing: .5px;
    background-color: #FFF;
    > li:first-child {
      display: table-cell;
      float: left;
      min-height: 38px;
      width: 45%;
      background-color: #FFF;
      text-transform: uppercase;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      padding: 13px 10px;
      position: relative;
      z-index: 2;
      vertical-align: middle;
      box-shadow: 0px 0px 10px 0 rgba(51, 51, 51, .2);
      > i {
        cursor: pointer;
        margin: 0 5px;
        transform: rotate(90deg);
        float: left;
      }
      @media (min-width: 640px) {
        width: 30%;
      }
      @media (min-width: 1280px) {
        width: 20%;
      }
      > span {
        cursor: pointer;
      }
    }
    > li:last-child {
      display: table-cell;
      float: left;
      min-height: 38px;
      width: 55%;
      padding: 4px 0;
      position: relative;
      &::before,
      &::after {
        content: "";
        height: 100%;
        position: absolute;
        top: 0;
        width: 30px;
        z-index: 1;
        background: #ffffff;
      }
      &::before {
        left: 0;
      }
      &::after {
        right: 0;
      }
      @media (min-width: 640px) {
        width: 70%;
      }
      @media (min-width: 1280px) {
        width: 80%;
      }
      > ul {
        padding: 0;
        width: calc(${props => props.props.items.filter(item => !item.collapsed).length} * 100% - 64px);
        margin: 0 32px;
        position: absolute;
        white-space: nowrap;
        left: ${props => props.props.left+"px"};
        top: 50%;
        -webkit-transition: left .3s ease-in-out;
        -moz-transition: left .3s ease-in-out;
        -o-transition: left .3s ease-in-out;
        transition: left .3s ease-in-out;
        transform: translateY(-50%);

        > li {
          font-size: .875em;
          display: inline-block;
          width: 110px;
          padding: 0 10px 0 0;
          vertical-align: middle;
          position: relative;
          overflow: hidden;
          @media (min-width: 480px) {
            font-size: 1em;
            width: 130px;
          }
          > span {
            /* background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 8 8" stroke="#AAAAAA"><g transform="translate(0.600000, 2.000000)"><polyline points="0 0 1.5 2 0 4" vector-effect="non-scaling-stroke"></polyline><polyline transform="translate(5.750000, 2.000000) scale(-1, 1) translate(-5.750000, -2.000000)" points="5 0 6.5 2 5 4" vector-effect="non-scaling-stroke"></polyline></g></svg>');
            background-position: center right;
            background-repeat: none; */
            color: #333;
            cursor: default;
            overflow: hidden;
            line-height: 1.1;
            float: left;
            width: auto;
            word-wrap: break-word;
            word-break: keep-all;
            max-width: 91%;
            white-space: normal;
            text-transform: uppercase;
            > span {
              text-transform: none;
              color: #AAA;
            }
          }
          > i {
            cursor: pointer;
            display: none;
            height: 9px;
            width: 11px;
            margin: 0 5px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            svg {
              stroke: #AAA;
            }
            @media (min-width: 480px) {
              display: inline-block;
            }
          }
          &.collapsed {
            width: 70px;
            /* > span {
              background-image: url('data:image/svg+xml;utf8,<svg  viewBox="0 0 9 8" stroke="#AAAAAA"><polyline points="6 2 7.5 4 6 6" vector-effect="non-scaling-stroke"></polyline><polyline transform="translate(1.750000, 4.000000) scale(-1, 1) translate(-1.750000, -4.000000) " points="1 2 2.5 4 1 6" vector-effect="non-scaling-stroke"></polyline></svg>');
            } */
          }
        }
      }
    }
  }
`;

export default function ListHead (props) {
  const {items, toggleProp, sort, className} = props;
  return (
    <StyledListHead props={props} className={className}>
      <li>
        <Icon onClick={() => sort("name")} name={"expand"}/>
        <span onClick={() => sort("name")}>Product name</span>
      </li>
      <li>
        <ul>
          {items.map((item, index) => {
            return(
            <li key={index} className={item.collapsed ? "collapsed" : null} >
              <span
                onMouseOver={(e) => toggleTooltip(e, item)}
                onMouseOut={(e) => toggleTooltip()}
              >{item.collapsed ? shortLabels[item.key] || item.label.substr(0, 2) : item.label}<wbr/><span>{!!item.unit && !item.collapsed && ` (${item.unit})`}</span></span>
              <Icon onClick={() => toggleProp(index)} name={item.collapsed ? "expand" : "collapse"}/>
            </li>)
          })}
        </ul>
      </li>
    </StyledListHead>)
}

ListHead.propTypes = {
  icon: PropTypes.string,
};
